import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import barcode from "../../assets/images/services/barcode-documentation.jpeg"
import SideBar from "components/our-services/SideBar";

const DocumentationPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();

  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_5.title}</h2>
      <Tab.Container id="documentation-services" defaultActiveKey="first">
        <Row>
          <Row sm={12} className="justify-center nav-row">
            <Nav variant="pills" className="flex-row services-nav-tab">
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="first">
                  {lang.services.lists.list_5.nav_1.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="second">
                  {lang.services.lists.list_5.nav_2.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="third">
                  {lang.services.lists.list_5.nav_3.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="fourth">
                  {lang.services.lists.list_5.nav_4.title}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row>
            <Col>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <h6>{lang.services.lists.list_5.nav_1.sub_title}</h6>
                  <p>
                    {lang.services.lists.list_5.nav_1.paragraph_1}
                    <ul>
                      <li>{lang.services.lists.list_5.nav_1.list_1}</li>
                      <li>{lang.services.lists.list_5.nav_1.list_2}</li>
                    </ul>
                  </p>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_5.nav_1.paragraph_2}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <h6>{lang.services.lists.list_5.nav_2.sub_title}</h6>
                  <p>
                    {lang.services.lists.list_5.nav_2.paragraph}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <h6>{lang.services.lists.list_5.nav_3.sub_title}</h6>
                  {lang.services.lists.list_5.nav_3.paragraphs.map(l => <p>{l}</p>)}
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                  <h6>{lang.services.lists.list_5.nav_4.sub_title}</h6>
                  {lang.services.lists.list_5.nav_4.paragraphs.map(l => <p>{l}</p>)}
                </Tab.Pane>
              </Tab.Content>
            </Col>
            <SideBar barcode={barcode}/>
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default DocumentationPage;
